import { useThemeContext } from './useThemeContext';
export function useThemeValue() {
    return useThemeContext().themeValue;
}
